import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { authService } from "../../services/authService";
import { toast } from "react-toastify";
import "./login.css";

const ResetPassword = () => {
  const [formData, setFormData] = useState({
    new_password: "",
    confirm_password: "",
  });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const identifier = location.state?.identifier;
  const method = location.state?.method || "phone";
  const otp = location.state?.otp;
  const userType = location.state?.user_type;
  const email = location.state?.email;

  useEffect(() => {
    if (!identifier || !otp) {
      toast.error("Invalid request. Please complete OTP verification first.");
      navigate("/forget-password");
      return;
    }
  }, [identifier, otp, navigate]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const validatePassword = () => {
    if (formData.new_password.length < 6) {
      toast.error("Password must be at least 6 characters long");
      return false;
    }

    if (formData.new_password !== formData.confirm_password) {
      toast.error("Passwords do not match");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validatePassword()) {
      return;
    }

    setLoading(true);
    try {
      const data = {
        otp,
        new_password: formData.new_password,
        confirm_password: formData.confirm_password,
      };

      // If email is available, use email; otherwise use phone
      if (email) {
        data.email = email;
        data.phone = identifier; // Phone is used for OTP verification
      } else if (method === "phone") {
        data.phone = identifier;
      } else {
        data.email = identifier;
      }

      const response = await authService.resetPassword(data);

      if (response.success) {
        toast.success(
          response.message || "Password reset successfully! You can now login."
        );
        // Navigate to login after 2 seconds
        setTimeout(() => {
          navigate("/bookedu/login");
        }, 2000);
      } else {
        toast.error(response.message || "Failed to reset password");
      }
    } catch (error) {
      console.error("Reset password error:", error);
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Failed to reset password. Please try again.";

      // If OTP is invalid, redirect back to verify OTP
      if (
        errorMessage.toLowerCase().includes("otp") ||
        errorMessage.toLowerCase().includes("invalid")
      ) {
        toast.error(errorMessage);
        navigate("/verify-otp", {
          state: {
            identifier,
            method,
            user_type: userType,
            email: email,
          },
        });
      } else {
        toast.error(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        {/* Left Illustration */}
        <div className="login-left">
          <img src={process.env.PUBLIC_URL + "/login_page.jpg"} alt="Illustration" />
        </div>

        {/* Right Form */}
        <div className="login-right">
          <div className="logo-container">
            <img src={process.env.PUBLIC_URL + "/pickloo.jpeg"} alt="Pickloo Logo" className="logo" />
          </div>

          <h2>Reset Password</h2>
          <p>Enter your new password</p>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>New Password</label>
              <div style={{ position: "relative" }}>
                <input
                  type={showPassword ? "text" : "password"}
                  name="new_password"
                  value={formData.new_password}
                  onChange={handleChange}
                  placeholder="Enter new password (min 6 characters)"
                  required
                  minLength="6"
                  style={{ paddingRight: "40px" }}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "14px",
                    color: "#666",
                  }}
                >
                  {showPassword ? "Hide" : "Show"}
                </button>
              </div>
              <small
                style={{
                  color: "#666",
                  fontSize: "12px",
                  marginTop: "5px",
                  display: "block",
                }}
              >
                Minimum 6 characters
              </small>
            </div>

            <div className="form-group">
              <label>Confirm Password</label>
              <div style={{ position: "relative" }}>
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirm_password"
                  value={formData.confirm_password}
                  onChange={handleChange}
                  placeholder="Confirm new password"
                  required
                  minLength="6"
                  style={{ paddingRight: "40px" }}
                />
                <button
                  type="button"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "14px",
                    color: "#666",
                  }}
                >
                  {showConfirmPassword ? "Hide" : "Show"}
                </button>
              </div>
            </div>

            <button type="submit" className="login-btn" disabled={loading}>
              {loading ? "Resetting Password..." : "Reset Password"}
            </button>

            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <button
                type="button"
                onClick={() => navigate("/bookedu/login")}
                style={{
                  background: "none",
                  border: "none",
                  color: "#333",
                  cursor: "pointer",
                  textDecoration: "underline",
                  fontSize: "14px",
                }}
              >
                Back to Login
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
